import { Pipe, PipeTransform } from '@angular/core';

import { Loan } from '@shared/enums/loan-type.enum';
/*
 * Convert opportunity type to svg icons.
 * Usage:
 *   loan | padding
 * @example
 * // returns loan name
 * {{ 'Home' | padding:10:' ' }}
 */
@Pipe({
  name: 'padding'
})
export class PaddingPipe implements PipeTransform {
  transform(value: any, length: number, paddedStr: string = ' '): string {
    let result = `${value}`;
    while (result.length < length) {
      result = `${paddedStr}${result}`;
    }
    return result;
  }
}
